<div class="content-wrapper">
  <p class="text-cinza text-center" ng-show="!cards.hasAnything() && !cards.loading && !cards.searching">
    Nenhum registro encontrado...
  </p>

  <div class="summary" ng-show="!cards.hasActivities() && cards.hasSummary()">
    <div ng-show="cards.summary.length && !(filters.cultivar && filters.cultivar.item_id !== 'todas')">
      <p class="history-day text-cinza" ng-hide="filters.cultura">
        Situação atual dos talhões
      </p>
      <p class="history-day text-cinza" ng-show="filters.cultura">
        Última situação de talhões com <b>{{filters.cultura.descricao}}</b>
        <i class="icon-info text-muted" aria-hidden="true"
           uib-tooltip="Os status listados abaixo são referentes aos talhões que tiveram {{filters.cultura.descricao}} em algum momento. Não representam necessariamente a situação atual."
           tooltip-placement="right" tooltip-append-to-body="true"></i>
      </p>
    </div>
    <div ng-show="cards.summary.length && filters.cultivar && filters.cultivar.item_id !== 'todas'">
        <p class="history-day text-cinza" ng-hide="filters.cultivar">
          Situação atual dos talhões
        </p>
        <p class="history-day text-cinza" ng-show="filters.cultivar">
          Última situação de talhões com <b>{{filters.cultivar.descricao}}</b>
          <i class="icon-info text-muted" aria-hidden="true"
             uib-tooltip="Os status listados abaixo são referentes aos talhões que tiveram {{filters.cultivar.descricao}} em algum momento. Não representam necessariamente a situação atual."
             tooltip-placement="right" tooltip-append-to-body="true"></i>
        </p>
      </div>

    <!-- Resumo -->
    <propriedade-card-summary ng-repeat="summary in cards.summary | orderBy:'dias_desde_a_ultima_acao'"
                              summary="summary"
                              class="panel panel-default-agro1 resumo-glebas"
                              ng-disabled="!summary.active"></propriedade-card-summary>
    <!-- Fim: Resumo -->

  </div>

  <div class="activities"
       ng-show="isHistorico || (cards.hasActivities() && !cards.loading)"
       infinite-scroll="cards.loadActivities()"
       infinite-scroll-container="'.sidebar-historico'"
       infinite-scroll-disabled="!isHistorico || !cards.hasPage || cards.loading">

    <!-- Itens -->
    <p class="history-activity-date"
       ng-repeat-start="activity in cards.activities"
       ng-if="cards.showActivityDate($index, activity)">
      {{cards.activityDate(activity.data)}}
    </p>
    <propriedade-card-activity ng-repeat-end
                               activity="activity"
                               filters="filters"
                               class="panel panel-default-agro1"
                               ng-class="{ unread: cards.isUnread(activity) }"
                               ng-disabled="!activity.active"
                               ng-if="cards.shouldShowActivity(activity)"></propriedade-card-activity>
    <!-- Fim: Itens -->

  </div>
</div>
<p class="text-cinza text-center preloader" ng-show="cards.loading || (cards.hasPage && isHistorico)">
  <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
</p>
